import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ReportStateStyledT = {
  isReportOpened: boolean;
};

type CardWrapStyledT = {
  isActive: boolean;
};

const reportHeaderHeight = 48;
const cardsBlockHeight = 185;
const cardsClosedTranslateValue = -(reportHeaderHeight + cardsBlockHeight);

export const CardsWrapStyled = styled(FlexContainer)<ReportStateStyledT>`
  width: 100%;
  max-height: ${({ isReportOpened }) => (isReportOpened ? '106px' : '0')};
  overflow-x: auto;
  overflow-y: hidden;
  transform: ${({ isReportOpened }) =>
    isReportOpened ? 'translateY(0)' : `translateY(${cardsClosedTranslateValue}px)`};
  z-index: 0;
  transition: max-height 0.25s linear, transform 0.3s linear;
`;

export const CardWrapStyled = styled(FlexContainer)<CardWrapStyledT>`
  flex-shrink: 0;
  min-width: 220px;
  margin: 6px;
  padding: 10px;
  position: relative;
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ isActive, theme }) =>
    isActive ? theme.colors.secondary.variant3 : theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.primary.variant6};
`;

export const InnerContentStyled = styled(FlexContainer)`
  align-self: baseline;
  gap: 10px;
  width: 100%;
`;

export const ClaimReportInnerContentStyled = styled(InnerContentStyled)`
  gap: 8px;
`;

export const GradesWrapStyled = styled.div`
  flex-shrink: 0;
`;

export const GradeLabelStyled = styled(Typography)`
  font-size: 0.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
  opacity: 0.3;
`;

export const FooterWrapStyled = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  min-height: 38px;
  background: ${({ theme }) => theme.colors.primary.variant3};
  padding: 7px 9px;
  border-radius: ${({ theme }) => theme.radius.lg};
`;

export const HeaderStyled = styled(FlexContainer)<ReportStateStyledT>`
  position: relative;
  flex-direction: column-reverse;
  gap: 0.5rem;
  align-items: end;
  margin-bottom: ${({ isReportOpened }) => (isReportOpened ? 0 : '10px')};
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  transition: margin-bottom 0.3s linear;
  z-index: 1;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      flex-direction: row;
      gap: 2rem;
      align-items: center;
    }
  `}
`;

export const AmountStyled = styled(Typography)`
  max-width: 70%;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
`;

export const InnerContentRowStyled = styled(FlexContainer)`
  width: 100%;
`;
